import script from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectLanguage.vue?vue&type=style&index=0&id=4b665c8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b665c8d"]])

export default __exports__